/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EbsSnapshotRestoreDestination } from '../models/EbsSnapshotRestoreDestination';

export class RestoreVolumeToEbsSnapshotRequest {
  /**
  * Cloud-provider-assigned ID of the volume to restore.
  */
  'providerVolumeId': string;
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': EbsSnapshotRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerVolumeId",
      "baseName": "providerVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "EbsSnapshotRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreVolumeToEbsSnapshotRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

